export default "__VITE_ASSET__4db09774__"